import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const SanityTestimonial = z.object({
  _key: z.string(),
  quote: z.string(),
  name: z.string(),
  role: z.string().optional().nullable(),
  image: SanityImage.optional().nullable(),
  logoMaxWidth: z.number().optional().nullable(),
  ueUrl: z.string().optional().nullable(),
});
export type SanityTestimonial = z.infer<typeof SanityTestimonial>;

export const testimonial = groq`{
  '_key': _id,
  quote,
  image ${image},
  logoMaxWidth,
  name,
  role,
  ueUrl,
}`;
